var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"platform-avatar",attrs:{"src":_vm.resolvedSrc,"alt":_vm.alt,"decoding":"async"},on:{"error":_vm.handleFailure}})
}
var staticRenderFns = []

export { render, staticRenderFns }